import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomToastrComponent } from './custom-toastr.component';
import { QdsButton, QuartzModule, QdsFormMessage } from "@quartzds/core-angular";

@NgModule({
  declarations: [CustomToastrComponent],
  imports: [CommonModule, QdsButton, QuartzModule, QdsFormMessage],
  exports: [CustomToastrComponent]
})
export class CustomToastrModule {}
